class GloboEmptyState {
    constructor() {
        this.filterHidden = false;
        this.init();
    }

    init() {
        window.addEventListener('globoProductCountUpdate', (e) => {
            const { visibleCount } = e.detail;
            if (visibleCount === 0) {
                this.showNoProductsMessage();
            } else {
                this.hideNoProductsMessage();
            }
        });
    }

    showNoProductsMessage() {
        let noProductsDiv = document.querySelector('.globo-no-products-message');

        if (!noProductsDiv) {
            noProductsDiv = document.createElement('div');
            noProductsDiv.className = 'globo-no-products-message';
            noProductsDiv.innerHTML = `
        <div class="title-wrapper center" style="padding: 40px 20px; text-align: center;">
          <strong class="title title--primary" style="font-size: 1.6rem; color: #253746;">
            SORRY, NO MATCH FOUND FOR YOUR SEARCH CRITERIA.
          </strong>
        </div>
      `;

            const productGrid = document.querySelector('#gf-products') ||
                document.querySelector('.product-grid-container') ||
                document.querySelector('.collection') ||
                document.querySelector('[class*="product-grid"]');

            if (productGrid) {
                productGrid.insertAdjacentElement('afterbegin', noProductsDiv);
            }
        }

        noProductsDiv.style.display = 'block';
        this.hideGloboDefaultMessage();
    }

    hideNoProductsMessage() {
        const noProductsDiv = document.querySelector('.globo-no-products-message');
        if (noProductsDiv) {
            noProductsDiv.style.display = 'none';
        }
        this.hideGloboDefaultMessage();
    }

    hideFilterSidebar() {
        if (this.filterHidden) return;

        const filterElements = document.querySelectorAll('.gf-tree, .gf-filter, .gf-filter-wrapper, .gf-refine, .gf-filter-header, .gf-sidebar, .gf-canvas, .gf-container, #gf-tree, [class*="gf-filter"], [class*="gf-tree"]');
        filterElements.forEach(el => {
            if (el) {
                el.setAttribute('data-was-visible', el.style.display || '');
                el.style.display = 'block';
            }
        });

        const facetElements = document.querySelectorAll('.facets-vertical, .facets-wrapper, #main-collection-filters, .sidebar-filter, .container-filter-desktop');
        facetElements.forEach(el => {
            if (el) {
                el.setAttribute('data-was-visible', el.style.display || '');
                el.style.display = 'none';
            }
        });

        this.filterHidden = true;
    }

    showFilterSidebar() {
        if (!this.filterHidden) return;

        const filterElements = document.querySelectorAll('.gf-tree, .gf-filter, .gf-filter-wrapper, .gf-refine, .gf-filter-header, .gf-sidebar, .gf-canvas, .gf-container, #gf-tree, [class*="gf-filter"], [class*="gf-tree"]');
        filterElements.forEach(el => {
            if (el && el.hasAttribute('data-was-visible')) {
                const wasVisible = el.getAttribute('data-was-visible');
                if (wasVisible) {
                    el.style.display = wasVisible;
                } else {
                    el.style.removeProperty('display');
                }
                el.removeAttribute('data-was-visible');
            }
        });

        const facetElements = document.querySelectorAll('.facets-vertical, .facets-wrapper, #main-collection-filters, .sidebar-filter, .container-filter-desktop');
        facetElements.forEach(el => {
            if (el && el.hasAttribute('data-was-visible')) {
                const wasVisible = el.getAttribute('data-was-visible');
                if (wasVisible) {
                    el.style.display = wasVisible;
                } else {
                    el.style.removeProperty('display');
                }
                el.removeAttribute('data-was-visible');
            }
        });

        this.filterHidden = false;
    }

    centerProductGrid() {
        const productGridUl = document.querySelector('ul.grid.product-grid') ||
            document.querySelector('.product-grid') ||
            document.querySelector('#gf-products');

        if (productGridUl) {
            productGridUl.setAttribute('data-original-display', productGridUl.style.display || '');
            productGridUl.setAttribute('data-original-justify', productGridUl.style.justifyContent || '');

            productGridUl.style.display = 'flex';
            productGridUl.style.justifyContent = 'normal';
        }
    }

    restoreProductGrid() {
        const productGridUl = document.querySelector('ul.grid.product-grid') ||
            document.querySelector('.product-grid') ||
            document.querySelector('#gf-products');

        if (productGridUl && productGridUl.hasAttribute('data-original-display')) {
            const originalDisplay = productGridUl.getAttribute('data-original-display');
            const originalJustify = productGridUl.getAttribute('data-original-justify');

            productGridUl.style.display = originalDisplay;
            productGridUl.style.justifyContent = originalJustify;

            productGridUl.removeAttribute('data-original-display');
            productGridUl.removeAttribute('data-original-justify');
        }
    }

    hideGloboDefaultMessage() {
        const globoDefaultMessages = document.querySelectorAll('[class*="spf-col"]');
        globoDefaultMessages.forEach(el => {
            if (el && el.textContent.trim().includes('Sorry, there are no products in this collection')) {
                el.setAttribute('data-was-visible', el.style.display || '');
                el.style.display = 'none';
            }
        });
    }

    showGloboDefaultMessage() {
        const globoDefaultMessages = document.querySelectorAll('[class*="spf-col"]');
        globoDefaultMessages.forEach(el => {
            if (el && el.hasAttribute('data-was-visible') && el.textContent.trim().includes('Sorry, there are no products in this collection')) {
                const wasVisible = el.getAttribute('data-was-visible');
                el.style.display = wasVisible;
                el.removeAttribute('data-was-visible');
            }
        });
    }
}

new GloboEmptyState();
